const DECIMAL_15_2 = /^\d{1,13}(\.\d{1,2})?$/;
const NON_NEGATIVE_INTEGER = /^\d+$/;
const MAX_LENGTHS: Record<string, number> = {
    number: 100,
    barcode: 100,
    name: 255,
    area: 200,
    unit: 50,
};

export const validateProductField = (field: string, value: unknown): string | null => {
    if (value === '' || value == null) return null;

    const text = String(value);
    const maxLength = MAX_LENGTHS[field];
    if (maxLength && [...text].length > maxLength) return `Maximum ${maxLength} characters.`;

    if (field === 'default_layout') {
        return NON_NEGATIVE_INTEGER.test(text) && Number(text) <= 65535
            ? null
            : 'Only numbers from 0 to 65,535 are allowed.';
    }

    if (field === 'price' || field === 'promo_price') {
        return DECIMAL_15_2.test(text) ? null : 'Maximum 13 digits and 2 decimal places.';
    }

    return null;
};
